import {Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class LazyDialogService {
  constructor(private dialog: MatDialog) {}

  async openDialog(
    activityComponentName: string,
    config: MatDialogConfig,
  ): Promise<MatDialogRef<any>> {
    if (typeof activityComponentName !== 'string' || activityComponentName.length === 0) {
      return null;
    }

    const moduleImport = await import('./dialogs/activity-dialogs.module');
    const dialogComponent =
      moduleImport.ActivityDialogsModule.getDialogComponentForName(activityComponentName);
    return this.dialog.open(dialogComponent, config);
  }
}
